var map = {
	"./01, Giant moving 02, Ausstellungsansicht.webp": 2540,
	"./09, Wraps 01, Ausstellungsansicht.webp": 5836,
	"./12, a picture of a scene (native mansion), Ausstellungsansicht.webp": 980,
	"./13, cluster frameworks (native mansion), Ausstellungsansicht.webp": 7880,
	"./14, It`s not me, it`s you (pattern paintings), Ausstellungsansicht.webp": 2500,
	"./15, Local`s reunion 03, Ausstellungsansicht.webp": 8978
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5258;